import backend from "./backend.ts";

export const config = { backend };
